import { useMemo } from 'react';

// Only these currencies can currently be onramped from. Restricting the
// country list to countries whose currency is in this set — rather than
// filtering by country code directly — means adding a new onramp currency
// later only requires editing this array, not maintaining a country list.
const ONRAMP_CURRENCIES = ['GBP', 'EUR', 'USD'];

/**
 * Filters a list of countries down to those whose currency is currently
 * supported for onramping, and derives the react-select option list from
 * that filtered set.
 *
 * @param {Array<{code: string, name: string, currency: string, dialCode: string}>} countries
 * @returns {{
 *   eligibleCountries: Array,
 *   countryOptions: Array<{ value: string, label: string }>,
 * }}
 */
export function useEligibleCountries(countries) {
  const eligibleCountries = useMemo(
    () =>
      (countries ?? []).filter((c) =>
        ONRAMP_CURRENCIES.includes(c.currency)
      ),
    [countries]
  );

  const countryOptions = useMemo(
    () =>
      eligibleCountries.map((c) => ({
        value: c.code,
        label: c.name,
      })),
    [eligibleCountries]
  );

  return { eligibleCountries, countryOptions };
}